<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
    <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent' : ''">
      <div class="row align-items-center">
        <div id="errorNotification" class="col-md-12">
          <base-alert v-if="errorMessage != null" type="danger">
            <span class="alert-inner--text"> {{ errorMessage }}</span>
            <button type="button" class="close" aria-label="Close" @click="removeMessage('error')">
              <span aria-hidden="true">&times;</span>
            </button>
          </base-alert>
          <base-alert v-if="successMessage != null" type="success">
            <span class="alert-inner--text"> {{ successMessage }}</span>
            <button type="button" class="close" aria-label="Close" @click="removeMessage('success')">
              <span aria-hidden="true">&times;</span>
            </button>
          </base-alert>
        </div>
        <div class="col-md-3">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
            {{ _.startCase(currentProfile) }}
          </h3>
        </div>
        <div class="col-md-9 text-right">
          <base-dropdown class="nav-link pr-0 float-right" position="right">
            <div class="media align-items-center" slot="title">
              <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
            </div>
            <template>
              <div class=" dropdown-header noti-title">
                <h6 class="text-overflow m-0">ACTIONS</h6>
              </div>
              <div class="dropdown-item" v-if="accessRights.includes('T')"
                @click.prevent="showActionDrawer('print_list')">
                <i class="fa fa-print"></i>
                <span>Print</span>
              </div>
              <div v-if="serverType == 'ho' && accessRights.includes('I')" class="dropdown-item"
                @click.prevent="showActionDrawer('import_list')">
                <i class="fa fa-upload"></i>
                <span>Import</span>
              </div>
              <div v-if="accessRights.includes('E')" class="dropdown-item"
                @click.prevent="showActionDrawer('export_list')">
                <i class="fa fa-download"></i>
                <span>Export</span>
              </div>
              <div class="dropdown-item" @click.prevent="showActionDrawer('customize_list')">
                <i class="fa fa-list-ul"></i>
                <span>Customize List</span>
              </div>
            </template>
          </base-dropdown>

          <div v-if="serverType == 'ho'">
            <div v-if="checkedItems.length == 0 && accessRights.includes('A')">
              <base-button class="float-right ml-1" type="primary" size="sm" @click.prevent="showDrawer(0)"
                v-b-modal.settings-modal>
                + Add {{ _.startCase(_.singularize(currentProfile)) }}
              </base-button>
            </div>

            <div v-else-if="checkedItems.length > 0 && accessRights.includes('W')">
              <base-button v-if="this.$parent.filterStatus != 'A'" class="float-right ml-1" type="primary" size="sm"
              @click.prevent="massupdate('status', 'A')">Activate</base-button>
              <base-button v-if="this.$parent.filterStatus != 'I'" class="float-right ml-1"  size="sm"
              @click.prevent="massupdate('status', 'I')">Deactivate</base-button>
              <base-button v-if="(this.$parent.filterStatus != 'A' && checkedItems.length === 1 && currentProfile === 'terminal_templates') 
              || (this.$parent.filterStatus != 'A' && checkedItems.length === 1 && currentProfile === 'terminals')" class="float-right ml-1" type="info" size="sm"
              @click.prevent="showDrawer(0)">Duplicate</base-button>
              <div class="ml-1"></div>
            </div>
          </div>

        </div>

      </div>

    </div>

    <a-drawer title="" :width="windowWidth" placement="right" @close="onClose" :visible="visible">
      <div v-if="viewMode == false">
        <div v-if="currentProfile == 'terminals'">
          <div v-if="formId == 'addTerminal'">Add Terminal</div>
          <div v-else>Edit Terminal - {{ this.formSettings["name"] }}</div>
        </div>
        <div v-else>
          <div v-if="formId == 'addTerminal'">Add Terminal Template</div>
          <div v-else>Edit Terminal Template - {{ this.formSettings["name"] }}</div>
        </div>
      </div>
      <div v-else>
        <div v-if="currentProfile == 'terminals'">View Terminal - {{ this.formSettings["name"] }}</div>
        <div v-else>View Terminal Template - {{ this.formSettings["name"] }}</div>
      </div>

      <template slot="default">
        <div class="row px-4" style="padding-left: 45px; padding-right: 45px;">
          <div class="col-md-3"
            style="border-right: 1px solid #e0e0e0; height: 75vh; max-height: 75vh; overflow: scroll">
            <br>

            <a-collapse v-model="activeKey" @change="headerClick" :accordion="accordion" style="margin-right: 20px">
              <a-collapse-panel v-for="header in headerList" :header="header.name" :key="header.id.toString()">
                <dynamic-tree v-if="header.id == activeKey" :headerId="header.id" :key="componentKey"
                  @selectNode="selectNode" :defaultSelected="true"></dynamic-tree>
              </a-collapse-panel>
            </a-collapse>

          </div>
          <div class="col-md-9" style="height: 75vh; max-height: 75vh; overflow: scroll">
            <div v-if="convertedJson == null">
              <br>
              <small class="ml-5">Please select a category</small>
            </div>
            <div v-else>
              <!-- {{formSettings}} -->
              <dynamic-form ref="dynamicForm" :convertedJson="convertedJson" @valueUpdated="updateSettings"
                :key="formKey" :formSettings="formSettings"></dynamic-form>
            </div>
          </div>
          <!-- <div class="col-md-12" style="height: 75vh; max-height: 75vh; overflow: scroll">
                  <pos-main-menu></pos-main-menu>
                </div> -->
        </div>
      </template>

      <div v-if="viewMode == false" class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
        <b-button variant="default" @click.prevent="onClose">
          Cancel
        </b-button>
        <b-button variant="success" :disabled="isLoading" @click.prevent="saveData">
          Save
        </b-button>
      </div>

    </a-drawer>

    <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="drawerVisible">
      <div v-if="profileAction == 'customize_list'">
        <h6 class="heading-small text-muted mb-4">Customize Fields</h6>
        <small>Check the fields that you want to see on the list. Drag the fields to
          specify position.</small>
        <br /><br />

        <div class="list-group list-group-item">
          <div class="row">
            <div class="col-md-6"><b>AVAILABLE FIELDS</b></div>
            <div class="col-md-6">
              <a-checkbox class="float-right" @change="onCheckAllField" :checked="
                this.checkedFields.length == this.availableFields.length
              " />
            </div>
          </div>
        </div>

        <draggable :key="draggableKey" :list="availableFields" class="list-group" @start="dragging = true"
          @end="dragging = false">
          <div class="list-group-item draggable"
            :style="index == availableFields.length - 1 ? 'margin-bottom: 50px;' : ''"
            v-for="(element, index) in availableFields" :key="element">
            <div class="row">
              <!-- This _.startCase() will convert any casing into Start Case -->
              <div v-if="element == 'id'" class="col-md-6">
                {{ _.startCase(_.singularize(currentProfile)) + " ID" }}
              </div>
              <div v-else class="col-md-6">
                {{ _.startCase(element) }}
              </div>
              <div class="col-md-6">
                <a-checkbox class="float-right" @change="onCheckField(element)"
                  :checked="checkedFields.includes(element)" />
              </div>
            </div>
          </div>
        </draggable>

        <div class="float-right" style="position: absolute; bottom: 20px; right: 20px">
          <button class="btn btn-primary float-right" @click.prevent="updateTableList">
            Update List
          </button>
        </div>
      </div>

      <div v-if="profileAction == 'export_list'">
        <h6 class="heading-small text-muted mb-4">Export Options</h6>
        <base-alert v-if="errors.length" type="danger">
          <b>You have the following error(s):</b>
          <ul>
            <li v-for="error in errors" :key="error">{{ error }}</li>
          </ul>
        </base-alert>
        <div>
          <a-radio-group v-model="exportSelection">
            <a-radio :style="radioStyle" :value="0">Export All</a-radio>
            <a-radio :style="radioStyle" :value="1">Export Current Page</a-radio>
            <a-radio :style="radioStyle" :value="2">Export Selected</a-radio>
            <a-radio :style="radioStyle" :value="3">Export Filtered</a-radio>
          </a-radio-group>
        </div>
        <div
          style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
          <button type="button" class="btn btn-primary float-right" @click.prevent="download">Export</button>
        </div>
      </div>

      <div v-if="profileAction == 'print_list'">
        <h6 class="heading-small text-muted mb-4">Print Options</h6>
      </div>

      <div v-if="profileAction == 'import_list'">
        <import-profile @closeDrawer="closeDrawer"></import-profile>
      </div>
    </a-drawer>

    <a-drawer title="" :width="800" placement="right" @close="onClose" :visible="historyVisible">
      <div>
        <h6 v-if="currentProfile == 'terminal_templates'" class="heading-small text-muted mb-4 text-truncate">Terminal Templates Action History</h6>
        <h6 v-else-if="currentProfile == 'terminals'" class="heading-small text-muted mb-4 text-truncate">Terminal Action History</h6>
        <a-table :columns="historyColumns" :dataSource="historyData" size="small" />
      </div>
      <div class="row">
        <div v-if="currentProfile == 'terminal_templates'" class="card-body">
          <h3>Detailed Template Histories</h3>
          <div class="col-md-8">
            <base-input alternative="">
              <h6 class="heading-small text-muted mb-4">History Date</h6>
              <a-range-picker v-model="detailTeminalTemplateHistoryDate"
                              format="MM-DD-YYYY"
                              :placeholder="['Start Date', 'End Date']"
                              style="width:70%"/>
                              <button class="btn btn-sm btn-default float-right" @click.prevent="getTerminalTemplateHistoryData">Apply Filter</button>
            </base-input>  
          </div>
          <br>
          <a-spin :spinning="spinning">
            <div class="table-responsive" >
              <vuetable ref="vuetable1" v-if="tableURL.length > 0"
              :api-url="tableURL"
              :http-options="httpOptions"
              :fields="teminalTemplateHistoryFields"
              :show-sort-icons="true"
              :per-page="10"
              :css="tableCSS.table"
              pagination-path=""
              data-path="data"
              no-data-template="Empty"
              @vuetable:load-error="onLoadError1"
              @vuetable:pagination-data="onPaginationData1"/>
            </div>
            <div class="card-footer d-flex justify-content-end bg-transparent">
              <div class="pagination ui basic segment grid">
                <vuetable-pagination
                  ref="pagination1"
                  @vuetable-pagination:change-page="onChangePage1"
                  :css="tableCSS.pagination">
                </vuetable-pagination>
              </div>
            </div>
          </a-spin>
        </div>
        <div v-else-if="currentProfile == 'terminals'" class="card-body">
          <h3>Detailed Terminal Histories</h3>
          <div class="col-md-8">
            <base-input alternative="">
              <h6 class="heading-small text-muted mb-4">History Date</h6>
              <a-range-picker v-model="detailTerminalHistoryDate"
                              format="MM-DD-YYYY"
                              :placeholder="['Start Date', 'End Date']"
                              style="width:70%"/>
                              <button class="btn btn-sm btn-default float-right" @click.prevent="getTerminalHistoryData">Apply Filter</button>
            </base-input>  
          </div>
          <br>
          <a-spin :spinning="spinning">
            <div class="table-responsive" >
              <vuetable ref="vuetable1" v-if="tableURL.length > 0"
              :api-url="tableURL"
              :http-options="httpOptions"
              :fields="teminalTemplateHistoryFields"
              :show-sort-icons="true"
              :per-page="10"
              :css="tableCSS.table"
              pagination-path=""
              data-path="data"
              no-data-template="Empty"
              @vuetable:load-error="onLoadError1"
              @vuetable:pagination-data="onPaginationData1"/>
            </div>
            <div class="card-footer d-flex justify-content-end bg-transparent">
              <div class="pagination ui basic segment grid">
                <vuetable-pagination
                  ref="pagination1"
                  @vuetable-pagination:change-page="onChangePage1"
                  :css="tableCSS.pagination">
                </vuetable-pagination>
              </div>
            </div>
          </a-spin>
        </div>
      </div>
    </a-drawer>

    <div class="table-responsive">
      <a-spin :spinning="getData">
                <vuetable
          ref="vuetable"
          :api-url="apiURL"
          :http-options="httpOptions"
          :fields="fields"
          :sort-order="sortOrder"
          :show-sort-icons="true"
          :per-page="10"
          :css="css.table"
          pagination-path=""
          data-path="data"
          no-data-template="Empty"
          @vuetable:checkbox-toggled-all="log"
          @vuetable:checkbox-toggled="log"
          @vuetable:load-error="onLoadError"
          @vuetable:pagination-data="onPaginationData"
        >
          <template slot="actions" slot-scope="props">
            <center>
              <div v-if="serverType == 'ho'" class="table-button-container">
                <button
                  id="history"
                  class="btn btn-primary btn-sm"
                  @click.prevent="showHistoryDrawer(props.rowData.id)"
                >
                  History
                </button>
                <button
                  id="view"
                  class="btn btn-success btn-sm"
                  v-if="accessRights.includes('V')"
                  @click.prevent="showDrawer(props.rowData.id)"
                >
                  View
                </button>
                <!-- <button id="view" class="btn btn-success btn-sm" @click.prevent="showDrawer(props.rowData.id)" v-b-modal.settings-modal>View</button>&nbsp;&nbsp; -->
                <button
                  v-if="accessRights.includes('W')"
                  class="btn btn-warning btn-sm"
                  @click.prevent="showDrawer(props.rowData.id)"
                  v-b-modal.settings-modal
                >
                  Edit
                </button>
                <!-- <button class="btn btn-danger btn-sm" v-if="(currentProfile != 'payment_types')" @click.prevent="deleteRow(props.rowData.id)">Delete</button>&nbsp;&nbsp; -->
                <a-popconfirm
                  v-if="accessRights.includes('D')"
                  title="You are about to delete this record?"
                  @confirm="deleteRow(props.rowData.id)"
                  okText="Delete"
                  cancelText="Cancel"
                >
                  <a class="btn btn-danger btn-sm text-white">Delete</a>
                </a-popconfirm>
              </div>
              <div v-else class="table-button-container">
                <button
                  id="history"
                  class="btn btn-primary btn-sm"
                  @click.prevent="showHistoryDrawer(props.rowData.id)"
                >
                  History
                </button>
                <button
                  id="view"
                  class="btn btn-success btn-sm"
                  @click.prevent="showDrawer(props.rowData.id)"
                  v-b-modal.settings-modal
                >
                  View</button
                >&nbsp;&nbsp;
              </div>
            </center>
          </template>
        </vuetable>
      </a-spin>
    </div>

    <div class="card-footer d-flex justify-content-end" :class="type === 'dark' ? 'bg-transparent' : ''">
      <div class="pagination ui basic segment grid">
        <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage" :css="css.pagination">
        </vuetable-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";


import {
  mapState,
  mapActions
} from 'vuex'

import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import secureStorage from '../../controllers/secureStorage';
import HTTPRequest from '../../controllers/httpRequest.js';
import ValidateField from '../../components/validateFormUtils.js';
import draggable from "vuedraggable";
import { compareJsonObject } from '../../utilities';

var ObjGen = require('../../../node_modules/objgen/objgen.js').ObjGen;
import DynamicForm from '../DynamicForm.vue'
import PosMainMenu from '../PosMainMenu.vue'
import DynamicTree from '../DynamicTree.vue'
import ImportProfile from '../ImportProfile';
import moment from "moment"

import { formatStatus } from "../../utilities.js"

var component_x;

export default {
  name: 'profiles-table',
  props: {
    type: {
      type: String
    },
    title: String
  },
  components: {
    Vuetable,
    VuetablePagination,
    DynamicForm,
    DynamicTree,
    PosMainMenu,
    ImportProfile,
    draggable,
  },
  computed: {
    ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'profileId', 'parameters', 'serverType'])
  },
  data() {
    return {
      isLoading: false,
      getData: false,
      formErrors: [],
      errors: [],
      exportSelection: 0,
      windowWidth: 0,
      viewMode: false,
      accessRights: [],
      selectedHeaderId: null,
      selectedId: null,
      clickFirst: true,
      activeKey: [],
      headerListComponent: 0,
      headerList: null,
      showAddCategory: false,
      selectedHeader: null,
      accordion: true,
      formKey: 0,
      formSettings: {},
      convertedJson: null,
      expandedKeys: [],
      autoExpandParent: true,
      showLine: true,
      formId: "",
      selectedNode: null,
      filterStatus: "",
      profileAction: "",
      checkedFields: [],
      checkedItems: [],
      availableFields: [],
      errorMessage: null,
      successMessage: null,
      componentKey: 0,
      drawerVisible: false,
      visible: false,
      apiURL: "",
      historyVisible: false,
      historyData: [],
      historyColumns: [
        {
          title: 'Action',
          dataIndex: 'action',
        },
        {
          title: 'Action By',
          dataIndex: 'action_by',
        },
        {
          title: 'Action At',
          dataIndex: 'action_at',
          customRender: (value) => <div>{moment(value).format('YYYY-MM-DD HH:mm:ss A')}</div>
        },
      ],
      fields: [],
      sortOrder: [{
        field: "name",
        direction: "asc"
      }],
      httpOptions: {
        headers: {
          Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web"
        }
      },
      css: {
        table: {
          tableClass: 'table table-sm table-striped table-bordered table-hovered',
          loadingClass: 'loading'
        },
        pagination: {
          infoClass: 'pull-right',
          wrapperClass: 'vuetable-pagination pull-right',
          activeClass: 'btn-primary btn-sm',
          disabledClass: 'disabled',
          pageClass: 'btn btn-border',
          linkClass: 'btn btn-border',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        }
      },
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
      },
      teminalTemplateHistoryFields: [
        {name: "setting", title: "Setting"},
        {name: "before_value", title: "From"},
        {name: "new_value", title: "To"},
        {name: "updated_by", title: "Updated By"},
        {name: "updated_at", title: "Updated At", 
        callback: (value) => { 
            return (value === null)
              ? ''
              : moment(value).format('YYYY-MM-DD HH:mm:ss A')
          }},
      ],
      detailTeminalTemplateHistoryDate: [moment().startOf('day'), moment().endOf('day')],
      detailTerminalHistoryDate: [moment().startOf('day'), moment().endOf('day')],
      tableURL: '',
      terminalTemplateId: -1,
      terminalId: -1,
      tableCSS: {
        table: {
          tableClass: 'table table-sm table-striped table-bordered table-hovered',
          loadingClass: 'loading'
        },
        pagination: {
          infoClass: 'pull-right',
          wrapperClass: 'vuetable-pagination pull-right',
          activeClass: 'btn-primary btn-sm',
          disabledClass: 'disabled',
          pageClass: 'btn btn-border',
          linkClass: 'btn btn-border',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        }
      },
      currentChangeFormSetting:[],
      currentChangeSettingStatus:false,
      spinning:false
    }
  },
  watch: {
    currentApiURL: function () {
      this.$refs.vuetable.resetData()
      this.apiURL = this.currentApiURL
    },
    parameters: function () {
      this.getData = true
      this.apiURL = this.currentApiURL
      this.apiURL = this.apiURL + this.parameters
      this.$refs.vuetable.selectedTo = []
      this.checkedItems = []
      this.getData = false
    }
  },
  methods: {
    moment,
    ...mapActions(['updateProfileId']),
    validateForm() {
      this.$refs.dynamicForm.validateForm()
    },
    validateTerminalTemplateForm() {
      let errors = [];

      // Trim values of required data
      if (this.currentProfile == 'terminals') {
        if (this.formSettings["code"]) {
          this.formSettings["code"] = this.formSettings["code"].trim();
        }
        if (this.formSettings["name"]) {
          this.formSettings["name"] = this.formSettings["name"].trim();
        }
        if (this.formSettings["serial_no"]) {
          this.formSettings["serial_no"] = this.formSettings["serial_no"].trim();
        }
        if (this.formSettings["machine_no"]) {
          this.formSettings["machine_no"] = this.formSettings["machine_no"].trim();
        }
        if (this.formSettings["ptusmNumber"]) {
          this.formSettings["ptusmNumber"] = this.formSettings["ptusmNumber"].trim();
        }
        errors.push(ValidateField.required("Terminal Code", this.formSettings["code"]));
        errors.push(ValidateField.required("Terminal Name", this.formSettings["name"]));
        errors.push(ValidateField.required("Site Id", this.formSettings["site_id"]));
        errors.push(ValidateField.required("Terminal Template", this.formSettings["terminal_template_id"]));
        errors.push(ValidateField.required("Serial No.", this.formSettings["serial_no"]));
        errors.push(ValidateField.required("Machine Id No.", this.formSettings["machine_no"]));
        // errors.push(ValidateField.required("PTUSM Number", this.formSettings["permit_no"]));
        errors.push(ValidateField.required("PTUSM Issue Date", this.formSettings["ptusmDateIssued"]));
        errors.push(ValidateField.required("PTUSM Valid Until", this.formSettings["ptusmValidUntil"]));
        errors.push(ValidateField.required("POS Display Mode", this.formSettings["displayMode"]));
     
      } else {
        this.formSettings["name"] = this.formSettings["name"].trim();
        this.formSettings["template_code"] = this.formSettings["template_code"].trim();

        // Check if Template Name is empty
        errors.push(ValidateField.required("Template Name", this.formSettings["name"]));
        // Check if Template Code is empty
        errors.push(ValidateField.required("Template Code", this.formSettings["template_code"]));
      }
      // Filter errors array and return data that is not null
      errors = errors.filter(err => (err));

      // Show errors in DynamicForm component
      this.$refs.dynamicForm.addCustomErrors(errors);

      // Return boolean; if form is valid or invalid
      return !(errors.length > 0);
    },
    getHeaderId(headerId) {
      this.selectedHeaderId = headerId
      return headerId.toString()
    },
    async showHistoryDrawer(id) {
      if (this.currentProfile == "terminal_templates") {
        if (event.target.id == "history") {
          var userHistory = await HTTPRequest.getRequest(this.endPoint + "terminal_templates_action_histories/" + id + "?field_name=template_id", null);
          this.terminalTemplateId = id
          this.getTerminalTemplateHistoryData()
          this.historyData = userHistory
        }
      } else if (this.currentProfile == "terminals") {
        if (event.target.id == "history") {
          var userHistory = await HTTPRequest.getRequest(this.endPoint + "terminals_action_histories/" + id + "?field_name=terminal_id", null);
          this.terminalId = id
          this.getTerminalHistoryData()
          this.historyData = userHistory
        }
      }
      this.historyVisible = true
    },
    async create_terminal_template_action_history(action, id) {
      var selected = 0
      if (id) {
        selected = id
      } else {
        selected = this.selectedId
      }
      var actionHistoryPayload = {
        action: action,
        action_at: moment(new Date()),
        action_by: secureStorage.getItem("userName"),
        template_id: selected,
        status: "A"
      }
      await HTTPRequest.postRequest(this.endPoint + 'terminal_templates_action_histories', null, actionHistoryPayload)
      await this.createTerminalTemplateHistories(selected)
    },
    async createTerminalTemplateHistories(id){
      var payload = []
      this.currentChangeFormSetting.forEach(function(row) {
        payload.push({terminal_template_id:id,setting:row.key,before_value:row.old_value,new_value:row.new_value})
      });
      await HTTPRequest.postRequest(this.endPoint + 'terminal_template_histories', null, {payload:payload})
      this.currentChangeSettingStatus = false
    },
    async create_terminal_action_history(action, id) {
      var selected = 0
      if (id) {
        selected = id
      } else {
        selected = this.selectedId
      }
      var actionHistoryPayload = {
        action: action,
        action_at: moment(new Date()),
        action_by: secureStorage.getItem("userName"),
        terminal_id: selected,
        status: "A"
      }
      await HTTPRequest.postRequest(this.endPoint + 'terminals_action_histories', null, actionHistoryPayload)
      await this.createTerminalHistories(selected)
    },
    async createTerminalHistories(id) {
      var payload = []
      this.currentChangeFormSetting.forEach(function(row) {
        payload.push({terminal_id:id,setting:row.key,before_value:row.old_value,new_value:row.new_value})
      });
      await HTTPRequest.postRequest(this.endPoint + 'terminal_histories', null, {payload:payload})
      this.currentChangeSettingStatus = false
    },
    async saveData() {
      this.currentChangeSettingStatus = true
      if (this.isLoading) { return; }

      // delete this.formSettings["dummy"]
      var payload;
      var settingRequest;
      var settingPayload;

      // make loading true
      this.isLoading = true;

      if (this.formErrors.length > 0) {
        this.$notification['error']({
          message: 'Failed Operation',
          description: "Please put in the required fields"
        });
        this.isLoading = false;
        return
      }

      if (this.currentProfile == 'terminals') {

        if (!this.validateTerminalTemplateForm()) {
          this.isLoading = false;
          return;
        }

        let status = (this.formSettings["status"] == null) ? "A" : this.formSettings["status"]
        payload = {
          terminal: {
            code: this.formSettings["code"], name: this.formSettings["name"], status: status, serial_no: this.formSettings["serial_no"],
            site_id: this.formSettings["site_id"], machine_no: this.formSettings["machine_no"], permit_no: this.formSettings["permit_no"],
            terminal_template_id: this.formSettings["terminal_template_id"], is_hold: this.formSettings["is_hold"], is_for_resetting: this.formSettings["is_for_resetting"], reference_code: this.formSettings["reference_code"]
          }
        }

        var terminalRequest;
        if (this.formId == 'addTerminal') {
          terminalRequest = await HTTPRequest.postRequest(this.endPoint + "terminals", null, payload)
          this.selectedId = terminalRequest.id
          this.create_terminal_action_history("Create")
        } else {
          terminalRequest = await HTTPRequest.putRequest(this.endPoint + "terminals/" + this.selectedId, null, payload)
          this.create_terminal_action_history("Update")
        }

        console.log(":)")
        if (terminalRequest.error == undefined) {
          delete this.formSettings["code"]
          delete this.formSettings["name"]
          delete this.formSettings["serial_no"]
          delete this.formSettings["site_id"]
          delete this.formSettings["machine_no"]
          delete this.formSettings["permit_no"]
          delete this.formSettings["terminal_template_id"]
          delete this.formSettings["is_hold"]
          delete this.formSettings["is_for_resetting"]
          settingPayload = { terminal_setting: { terminal_id: terminalRequest.id, json_settings: JSON.stringify(this.formSettings) } }

          if (this.formId == 'addTerminal') {
            settingRequest = await HTTPRequest.postRequest(this.endPoint + "terminal_settings", null, settingPayload)
          } else {
            settingRequest = await HTTPRequest.putRequest(this.endPoint + "terminal_settings/" + this.selectedId + "?field_name=terminal_id", null, settingPayload)
          }

          if (settingRequest.error == undefined) {
            this.$root.$emit('bv::hide::modal', 'settings-modal');
            // alert("Succesful Operation")
            this.$notification['success']({
              message: 'Succesful Operation',
              description: "Terminal was saved successfully."
            });

            this.visible = false
            this.$refs.vuetable.refresh()
            this.formKey++
            this.formSettings = {}
            // this.activeKey = []
            // this.activeKey.push(this.headerList[0].id.toString())
          }
        } else {
          console.log(":(")
          this.formErrors.concat(terminalRequest.error)
          this.visible = true
          this.$notification['error']({
            message: 'Failed Operation',
            description: terminalRequest.error
          });
        }
      } else {
        // Terminal Template Validation
        if (!this.validateTerminalTemplateForm()) {
          this.isLoading = false;
          return;
        }

        payload = { terminal_template: { name: this.formSettings["name"], template_code: this.formSettings["template_code"] } }
        if (this.formId == 'addTerminal') {
          terminalRequest = await HTTPRequest.postRequest(this.endPoint + "terminal_templates", null, payload)
          this.selectedId = terminalRequest.id
          this.create_terminal_template_action_history("Create")
        } else {
          terminalRequest = await HTTPRequest.putRequest(this.endPoint + "terminal_templates/" + this.selectedId, null, payload)
          this.create_terminal_template_action_history("Update")
        }

        // Convert SC/PWD Discount Amounts to decimal
        if (this.formSettings["scDiscountPercent"])
          this.formSettings["scDiscountPercent"] = this.formSettings["scDiscountPercent"] / 100
        if (this.formSettings["pwdDiscountPercent"])
          this.formSettings["pwdDiscountPercent"] = this.formSettings["pwdDiscountPercent"] / 100
        if (this.formSettings["productComboValueSCDiscountRate"])
          this.formSettings["productComboValueSCDiscountRate"] = this.formSettings["productComboValueSCDiscountRate"] / 100
        if (this.formSettings["productComboValuePWDDiscountRate"])
          this.formSettings["productComboValuePWDDiscountRate"] = this.formSettings["productComboValuePWDDiscountRate"] / 100

        if (terminalRequest.error == undefined) {
          delete this.formSettings["code"]
          delete this.formSettings["name"]
          settingPayload = { terminal_setting: { terminal_template_id: terminalRequest.id, json_settings: JSON.stringify(this.formSettings) } }

          if (this.formId == 'addTerminal') {
            settingRequest = await HTTPRequest.postRequest(this.endPoint + "terminal_settings", null, settingPayload)
          } else {
            settingRequest = await HTTPRequest.putRequest(this.endPoint + "terminal_settings/" + this.selectedId + "?field_name=terminal_template_id", null, settingPayload)
          }

          if (settingRequest.error == undefined) {
            this.$root.$emit('bv::hide::modal', 'settings-modal');
            this.visible = false
            this.$notification['success']({
              message: 'Succesful Operation',
              description: "Terminal Template was saved successfully."
            });
            this.$refs.vuetable.refresh()
            this.formKey++
            this.formSettings = {}
            this.activeKey = []
            this.activeKey.push(this.headerList[0].id.toString())
          } else {
            this.$root.$emit('bv::hide::modal', 'settings-modal');
            this.visible = false
            this.$notification['warning']({
              message: 'Failed to save settings',
              description: settingRequest.error
            });
            this.$refs.vuetable.refresh()
            this.formKey++
            this.formSettings = {}
            this.activeKey = []
            this.activeKey.push(this.headerList[0].id.toString())
            // alert(settingRequest.error)
          }
        } else {
          this.$root.$emit('bv::hide::modal', 'settings-modal');
          this.visible = true
          this.$notification['error']({
            message: 'Failed Operation',
            description: terminalRequest.error
          });
          this.$refs.vuetable.refresh()
          this.formKey++
          // this.formSettings = {}
          // this.oldFormSettings = {}
          this.diff = {}
          
          // TODO: move sc/pwd conversion to backend? need to parse json_settings string, though
          // Revert SC/PWD Discount back when saving settings has failed
          if (this.formSettings["scDiscountPercent"])
            this.formSettings["scDiscountPercent"] = this.formSettings["scDiscountPercent"] * 100
          if (this.formSettings["pwdDiscountPercent"])
            this.formSettings["pwdDiscountPercent"] = this.formSettings["pwdDiscountPercent"] * 100
          if (this.formSettings["productComboValueSCDiscountRate"])
            this.formSettings["productComboValueSCDiscountRate"] = this.formSettings["productComboValueSCDiscountRate"] * 100
          if (this.formSettings["productComboValuePWDDiscountRate"])
            this.formSettings["productComboValuePWDDiscountRate"] = this.formSettings["productComboValuePWDDiscountRate"] * 100



          this.activeKey = []
          this.activeKey.push(this.headerList[0].id.toString())
        }
        this.isLoading = false;
      }
    
      setTimeout(() => {
        this.isLoading = false;
      }, 3000)
    },
    selectNode(value) {
      // alert("NODE SELECTED!!!!")
      this.selectedNode = value
      this.jsonField = value.scopedSlots.settings_template
      this.onSelect()
      // console.log(value)
    },
    headerClick() {
      // alert(this.activeKey[0])
      this.showAddCategory = true
      this.selectedHeader = this.activeKey[0]
      this.convertedJson = null
      this.selectedNode = null
      this.componentKey++
      this.formKey++
    },
    updateSettings(newFormSettings, settingsGrouping, errors) {
      var formSettingsCopy = this.formSettings
      if(!this.currentChangeSettingStatus){
        this.currentChangeFormSetting = compareJsonObject(formSettingsCopy,newFormSettings,this.currentChangeFormSetting)
      }
      var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
      this.formErrors = errors
      this.formSettings = mergedHash
    },
    closeDrawer() {
      this.onClose()
    },
    closeModal() {
      this.formSettings = null
      this.activeKey = []
      this.activeKey.push(this.headerList[0].id.toString())
      this.formKey++
      this.componentKey++
      this.$root.$emit('bv::hide::modal', 'settings-modal')
    },
    refreshPage() {
      this.onClose()
      this.$refs.vuetable.refresh()
      this.successMessage = "Successful Operation"
      this.errorMessage = null
    },

    async showDrawer(id) {
      // this.formId

      this.visible = true
      if (event.target.id == "view") {
        this.viewMode = true
      } else {
        this.viewMode = false
      }

      if (id == 0) {
        console.log(this.formSettings)
        this.formId = 'addTerminal'
        //Mount Master on New Terminal Template Record
        let master_template = await HTTPRequest.getRequest(this.endPoint + "terminal_templates?template_code=Master", null)
        let response;

        if (this.formSettings.id === undefined && this.formSettings.name === undefined) {
          if (this.currentProfile == "terminal_templates") {
            response = await HTTPRequest.getRequest(this.endPoint + "terminal_templates/" + master_template.data[0].id, null)
          }
          let jsonSettings = {}
          if (this.isJsonString(response["json_settings"]) == true) {
            jsonSettings = JSON.parse(response["json_settings"])
            delete response["json_settings"]
          }
          var basicDetails = response
          var mergedHash = Object.assign({}, jsonSettings, basicDetails);
          this.formSettings = mergedHash
        }
        this.formKey++

        // this.activeKey[0] = this.headerList[0].id.toString()
        this.activeKey = []
        this.activeKey.push(this.headerList[0].id.toString())
      } else {
        this.formId = 'editTerminal'
        this.selectedId = id

        let response;
        if (this.currentProfile == "terminals") {
          response = await HTTPRequest.getRequest(this.endPoint + "terminals/" + id, null)
        } else {
          response = await HTTPRequest.getRequest(this.endPoint + "terminal_templates/" + id, null)
        }

        let jsonSettings = {}
        if (this.isJsonString(response["json_settings"]) == true) {
          jsonSettings = JSON.parse(response["json_settings"])
          delete response["json_settings"]
        }

        let basicDetails = response
        let mergedHash = Object.assign({}, jsonSettings, basicDetails);

        // Display SC/PWD Discount Amount as Percentage
        if (mergedHash["scDiscountPercent"])
          mergedHash["scDiscountPercent"] = mergedHash["scDiscountPercent"] * 100
        if (mergedHash["pwdDiscountPercent"])
          mergedHash["pwdDiscountPercent"] = mergedHash["pwdDiscountPercent"] * 100
        if (mergedHash["productComboValueSCDiscountRate"])
          mergedHash["productComboValueSCDiscountRate"] = mergedHash["productComboValueSCDiscountRate"] * 100
        if (mergedHash["productComboValuePWDDiscountRate"])
          mergedHash["productComboValuePWDDiscountRate"] = mergedHash["productComboValuePWDDiscountRate"] * 100

        this.formSettings = mergedHash
        this.formKey++
      }
    },
    async showActionDrawer(action) {
      if (action == "customize_list") {
        var response = await HTTPRequest.getRequest(
          this.endPoint + this.currentProfile + "/get_viewable_fields",
          null
        );

        let unsortedFields = response["fields"];
        let sortedFields = this.checkedFields.slice();

        unsortedFields.forEach(fieldName => {
          if (!this.checkedFields.includes(fieldName))
            sortedFields.push(fieldName)
        });

        this.availableFields = sortedFields;

      }
      this.profileAction = action;
      this.drawerVisible = true;
    },
    isJsonString(str) {
      try {
        var json = JSON.parse(str);
        return (typeof json === 'object');
      } catch (e) {
        return false;
      }
    },
    onClose() {
      this.formSettings = {}
      this.checkedItems = []
      this.$refs.vuetable.selectedTo = []
      this.drawerVisible = false
      this.visible = false
      this.historyVisible = false
      this.componentKey++
    },
    async log() {
      this.checkedItems = this.$refs.vuetable.selectedTo
      if(this.checkedItems.length === 1) {
        let id = this.checkedItems[0]
        let response;
        if (this.currentProfile == "terminals") {
          response = await HTTPRequest.getRequest(this.endPoint + "terminals/" + id, null)
        }
        if (this.currentProfile == "terminal_templates") {
          response = await HTTPRequest.getRequest(this.endPoint + "terminal_templates/" + id, null)
        }
        
        let jsonSettings = {}
        if (this.isJsonString(response["json_settings"]) == true) {
          jsonSettings = JSON.parse(response["json_settings"])
          delete response["json_settings"]
        }
        let basicDetails = response
        let mergedHash = Object.assign({}, jsonSettings, basicDetails);

        // Display SC/PWD Discount Amount as Percentage
        if (mergedHash["scDiscountPercent"])
          mergedHash["scDiscountPercent"] = mergedHash["scDiscountPercent"] * 100
        if (mergedHash["pwdDiscountPercent"])
          mergedHash["pwdDiscountPercent"] = mergedHash["pwdDiscountPercent"] * 100
        if (mergedHash["productComboValueSCDiscountRate"])
          mergedHash["productComboValueSCDiscountRate"] = mergedHash["productComboValueSCDiscountRate"] * 100
        if (mergedHash["productComboValuePWDDiscountRate"])
          mergedHash["productComboValuePWDDiscountRate"] = mergedHash["productComboValuePWDDiscountRate"] * 100


        this.formSettings = mergedHash
      }
    },
    onCheckField(fieldName) {
      if (this.checkedFields.includes(fieldName)) {
        var indexValue = this.checkedFields.indexOf(fieldName);
        if (indexValue > -1) {
          this.checkedFields.splice(indexValue, 1);
        }
      } else {
        this.checkedFields.push(fieldName);
      }
    },
    onCheckAllField() {
      if (this.checkedFields.length == this.availableFields.length) {
        this.checkedFields = [];
      } else {
        this.checkedFields = this.availableFields.slice();
        this.fields = this.checkedFields.map(column => {
          if (column === "status") {
            return {
              name: "status",
              callback: (value) => formatStatus(value)
            }
          } else if (column === "id") {
            return {
              name: "id",
              title: _.startCase(_.singularize(this.currentProfile)) + " ID"
            }
          } else return column
        })
        this.fields.unshift("__checkbox");
        this.fields.push("__slot:actions");
      }
      let storeName = this.currentProfile + "POSProfileCheckedFields"
        localStorage.setItem(storeName, JSON.stringify(this.checkedFields))
      this.reinitializeFields();
    },
    reinitializeFields() {
      this.$nextTick(() => {
        this.$refs.vuetable.normalizeFields();
      });
    },
    async massupdate(field_name, value) {
      var field_update = {}
      field_update[field_name] = value
      var payload = {
        ids: this.checkedItems,
        field_update: field_update
      }
      var response = await HTTPRequest.postRequest(this.endPoint + this.currentProfile + "/mass_update", null,
        payload)
      if (response["message"] == "Ok") {
        this.successMessage = "Update successful!"
        for (let i = 0; i < this.$refs.vuetable.selectedTo.length; i++) {
          this.create_terminal_template_action_history("Update", this.$refs.vuetable.selectedTo[i])
        }
        this.$refs.vuetable.refresh()
        this.checkedItems = []
        this.$refs.vuetable.selectedTo = []
      } else {
        this.successMessage = "Update failed!"
      }
    },
    async onPaginationData(paginationData) {
      // await axios({
      //     method: 'PUT',
      //     url: this.endPoint.split("/api")[0] + "/api/v2/backend_sessions/" + secureStorage.getItem("sessionId") + "/update_timestamp",
      //     headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },
      // })
      this.$refs.pagination.setPaginationData(paginationData);
    },
    async onLoadError(error) {
      // request for new token or reauthenticate
      if (error.response.status == 401) {
        var auth_response = await HTTPRequest.authenticate(component_x.endPoint)
        if (auth_response["status"] == "Ok") {
          this.$router.go();
        } else {
          alert("Cannot get access token. Please login again.")
          this.$router.push("/")
        }
      } else {
        if (error.response.data.error == "Session expired") {
          alert("Session is already expired. Please login again.")
          document.getElementById("logoutButton").click()
        }
      }
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onLoadError1: async function(error) {
      console.log(error)
    },

    onPaginationData1: async function(paginationData) {
      this.$refs.pagination1.setPaginationData(paginationData);
    },

    onChangePage1(page) {
      this.$refs.vuetable1.changePage(page);
    },
    deleteRow(id) {
      axios({
        method: 'delete',
        url: this.endPoint + this.currentProfile + '/' + id,
        headers: {
          Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web"
        },
      })
        .then(function () {
          component_x.successMessage = "Successfully deleted record"
          component_x.$refs.vuetable.refresh()
        })
        .catch(function () {
          alert("Invalid Credentials")
        });
    },
    download() { // Must update other Profile Tables download function to be aligned
      var payload = {}
      var additional_parameters = ""
      var baseUrl = this.currentApiURL + "/download?file_type=csv"
      if (this.exportSelection == "0") {
        // All
        payload["type"] = "all"
      } else if (this.exportSelection == "1") {
        // Current Page
        var ids = this.$refs.vuetable.tableData.map(({ id }) => id)
        payload["type"] = "current_page";
        if (ids == 0) {
          this.errors.push('No Record(s)');
          return;
        } else {
          payload["ids"] = ids
        }

      } else if (this.exportSelection == "2") {
        // Selected
        payload["type"] = "selected"
        if (this.checkedItems == 0) {
          this.errors.push('No Selected Record(s)');
          return;
        } else {
          payload["ids"] = this.checkedItems
        }
      } else {
        // Filtered
        payload["type"] = "filtered"
        additional_parameters = this.parameters
      }

      var exportFields = this.fields
      var cbIndex = this.fields.indexOf("__checkbox");
      if (cbIndex > -1) exportFields.splice(cbIndex, 1)
      var actionIndex = this.fields.indexOf("__slot:actions");
      if (actionIndex > -1) exportFields.splice(actionIndex, 1)

      payload["fields"] = exportFields
      additional_parameters = additional_parameters.replace('?', '&');

      axios({
        url: baseUrl + additional_parameters,
        method: 'POST',
        responseType: 'blob', // important
        headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File" },
        data: payload,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'file.csv');
        document.body.appendChild(link);
        link.click();
        this.onClose();
        this.filterStatus = null
        this.successMessage = "Download successful"
      });
    },
    displayMessage(message) {
      if (message["error"] != undefined) {
        this.onClose()
        this.errorMessage = message["error"]
        this.successMessage = null
      }
    },
    removeMessage(type) {
      if (type == 'error')
        this.errorMessage = null
      else
        this.successMessage = null
    },
    getWindowWidth(event) { //for fullscreen drawer
      this.windowWidth = window.innerWidth
    },
    //   onExpand  (expandedKeys) {
    //   this.selectedNode = null
    //   this.expandedKeys = expandedKeys
    //   this.autoExpandParent = false
    // },
    // onChange (e) {
    //   const value = e.target.value
    //   const expandedKeys = dataList.map((item) => {
    //     if (item.title.indexOf(value) > -1) {
    //       return getParentKey(item.key, gData)
    //     }
    //     return null
    //   }).filter((item, i, self) => item && self.indexOf(item) === i)
    //   Object.assign(this, {
    //     expandedKeys,
    //     searchValue: value,
    //     autoExpandParent: true,
    //   })
    // },
    async onSelect() {
      var formTemplate = await HTTPRequest.getRequest(this.endPoint + 'terminal_settings_categories/' + this.selectedNode.key + "/get_template", null, null)
      this.convertedJson = ObjGen.xJson(formTemplate["template"], { numSpaces: 2 })
      this.formKey++;
    },
    isSelected(value) {
      this.activeKey[0] == value
    },
    updateTableList() {
      var reference_array = this.availableFields;
      var array = this.checkedFields;
      if (array.length) {
        array.sort(function (a, b) {
          return reference_array.indexOf(a) - reference_array.indexOf(b);
        });
        this.checkedFields = array;
      } else {
        this.checkedFields = ["id", "name", "status"];
        this.$notification['warning']({
          message: 'Customized columns cannot be empty',
          description: 'Columns reset to default.'
        })
      }

      let localStoreName = this.currentProfile + "POSProfileCheckedFields"
      localStorage.setItem(localStoreName, JSON.stringify(this.checkedFields));

      this.fields = this.checkedFields.map(column => {
        if (column === "status") {
          return {
            name: "status",
            callback: (value) => formatStatus(value)
          }
        } else if (column === "id") {
          return {
            name: "id",
            title: _.startCase(_.singularize(this.currentProfile)) + " ID"
          }
        } else return column
      })
      this.fields.push("__slot:actions");
      this.fields.unshift("__checkbox")

      this.reinitializeFields();
      this.onClose();
    },
    getTerminalTemplateHistoryData: async function() {
      var id = this.terminalTemplateId
      if(this.detailTeminalTemplateHistoryDate.length == 0){
          this.$notification["error"]({
          message: "History date is required",
          description: "Please fill in history date!",
        });
        return
      }

      this.spinning = true
      let tableURL = `${this.endPoint}terminal_template_histories?`;
      tableURL += `terminal_template_id=${id}`;
      tableURL += `&historyDateFrom=${this.detailTeminalTemplateHistoryDate[0].format('YYYY-MM-DD')}`;
      tableURL += `&historyDateTo=${this.detailTeminalTemplateHistoryDate[1].format('YYYY-MM-DD')}`;
      this.tableURL = tableURL
      this.spinning = false
    },
    getTerminalHistoryData: async function() {
      var id = this.terminalId
      if(this.detailTerminalHistoryDate.length == 0){
          this.$notification["error"]({
          message: "History date is required",
          description: "Please fill in history date!",
        });
        return
      }

      this.spinning = true
      let tableURL = `${this.endPoint}terminal_histories?`;
      tableURL += `terminal_id=${id}`;
      tableURL += `&historyDateFrom=${this.detailTerminalHistoryDate[0].format('YYYY-MM-DD')}`;
      tableURL += `&historyDateTo=${this.detailTerminalHistoryDate[1].format('YYYY-MM-DD')}`;
      this.tableURL = tableURL
      this.spinning = false

    }
    
  },
  beforeMount: async function () {
    const terminalPOSProfileCheckedFields = localStorage.getItem(this.currentProfile + "POSProfileCheckedFields")
    // console.log(terminalPOSProfileCheckedFields)
    if (terminalPOSProfileCheckedFields != undefined && terminalPOSProfileCheckedFields != null && terminalPOSProfileCheckedFields != "[]") {
      this.checkedFields = JSON.parse(terminalPOSProfileCheckedFields)
      this.fields = this.checkedFields.map(column => {
        if (column === "status") {
          return {
            name: "status",
            callback: (value) => formatStatus(value)
          }
        } else if (column === "id") {
          return {
            name: "id",
            title: _.startCase(_.singularize(this.currentProfile)) + " ID"
          }
        } else return column
      })
      this.fields.push("__slot:actions")
      this.fields.unshift("__checkbox")
      this.initLoad++
    } else {
      this.checkedFields = ["id", "name", "status"];
      this.fields = [
        "__checkbox",
        {
          name: "id",
          title: _.startCase(_.singularize(this.currentProfile)) + " ID"
        },
        "name",
        {
          name: "status",
          callback: (value) => formatStatus(value)
        },
        "__slot:actions"
      ];
      localStorage.removeItem(this.currentProfile + "POSProfileCheckedFields")
    }
  },
  mounted: async function () {
    // alert(this.currentProfile)
    this.viewMode = this.$attrs.viewMode
    this.accessRights = this.$attrs.accessRights
    if (this.currentProfile == "terminals") {
      this.headerList = await HTTPRequest.getRequest(this.endPoint + 'terminal_settings_category_headers?header_type=2', null, null)
    } else {
      this.headerList = await HTTPRequest.getRequest(this.endPoint + 'terminal_settings_category_headers?header_type=1', null, null)
    }

    this.activeKey.push(this.headerList[0].id.toString())
    component_x = this;
    this.apiURL = this.currentApiURL

    this.$nextTick(function () { //for fullscreen drawer
      window.addEventListener('resize', this.getWindowWidth);
      this.getWindowWidth()
    })

  }
}
</script>

<style scoped>
#settings-modal___BV_modal_content_ {
  border-radius: 0px;
  max-width: 100%;
  margin: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  display: flex;
  position: fixed;
  z-index: 100000;
}

.ant-collapse>.ant-collapse-item-active>.ant-collapse-header {
  background-color: #32325d;
  color: white;
}

.selected {
  background-color: #32325d;
  color: white;
}

.modal_content {
  max-width: 100%;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  display: flex;
  position: fixed;
  z-index: 100000;
  border-radius: 0px;
}

.modal-body {
  /* background-color: #F7F7F7; */
  background-color: white;
  border-top: 2px solid #e0e0e0;
  border-bottom: 2px solid #e0e0e0;
  padding-left: 80px;
  padding-right: 100px;
}

.draggable {
  cursor: grab
}
</style>
